import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { ItemTypeTotalStockListView, ItemTypeView } from '@nexelem/api';

type Item = ItemTypeTotalStockListView | ItemTypeView;
type ModalStore = { isOpen: boolean };

export enum ProductDetailsModalNames {
  DEACTIVATE_ITEM = 'DEACTIVATE_ITEM',
}

export type HandleModalState = (modalName: ProductDetailsModalNames) => void;

type ProductStore = {
  currentItem: Item;
  isActionLoading: boolean;
  setItem: (newItem: Item) => void;
  changeStatus: (status: Item['status']) => void;
  setIsActionLoading: (loadingState: boolean) => void;
  state: Record<ProductDetailsModalNames, ModalStore>;
  actions: {
    onToggleModal: HandleModalState;
  };
};

export const useProductDetailsStore = create(
  immer<ProductStore>((set) => {
    return {
      currentItem: {} as Item,
      isActionLoading: false,
      setItem: (currentItem) =>
        set(() => {
          return { currentItem };
        }),
      changeStatus: (status: Item['status']) =>
        set((state) => {
          state.currentItem.status = status;
        }),
      setIsActionLoading: (loadingState: boolean) =>
        set((state) => {
          state.isActionLoading = loadingState;
        }),
      state: {
        [ProductDetailsModalNames.DEACTIVATE_ITEM]: {
          isOpen: false,
        },
      },
      actions: {
        onToggleModal: (modalName) =>
          set((state) => {
            state.state[modalName].isOpen = !state.state[modalName].isOpen;
          }),
      },
    };
  }),
);
